import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  public dimensionesVideo = new BehaviorSubject<number>(null); //contado - credito
  dimensiones$ = this.dimensionesVideo.asObservable();

  public setChart(str, index, chr): string {
    if (index > str.length - 1) return str;
    return str.substr(0, index) + chr + str.substr(index + 1);
  }

  public getTitle(
    texto: string,
    withIndicator: boolean = false,
    searchText: string = ''
  ) {
    let retText: string = '';

    texto.split(' ').forEach((element) => {
      const str2 =
        element.toLowerCase().charAt(0).toUpperCase() +
        element.toLowerCase().slice(1);
      retText += str2 + ' ';
    });

    if (withIndicator && searchText.length > 0) {
      var regEx = new RegExp(searchText, 'ig');

      //incluye la palabra
      if (retText.match(regEx)) {

        retText = retText.replace(
          regEx,
          `<strong class="resaltado">${searchText}</strong>`
        );
        let strFormat: string[] = retText.split('<');


        if (
          strFormat[0].length == 0 ||
          strFormat[0].charAt(strFormat[0].length - 1) == ' '
        ) {
          //es primera palabra
          const str23 =
            searchText.toLowerCase().charAt(0).toUpperCase() +
            searchText.toLowerCase().slice(1);
          retText = retText.replace(`>${searchText}<`, `>${str23}<`);
        }
      }
    }
    return retText;
  }

  isJson(json: string): boolean {
    try {
      JSON.parse(json);
    } catch (e) {
      return false;
    }
    return true;
  }

  getCFDIData(key: any) {
    let CFDI = [
      { key: 'G01', description: 'Adquisición de mercancias.' },
      { key: 'G02', description: 'Devoluciones, descuentos o bonificaciones.' },
      { key: 'G03', description: 'Gastos en general.' },
      { key: 'I01', description: 'Construcciones.' },
      {
        key: 'I02',
        description: 'Mobilario y equipo de oficina por inversiones.',
      },
      { key: 'I03', description: 'Equipo de transporte.' },
      { key: 'I04', description: 'Equipo de computo y accesorios.' },
      {
        key: 'I05',
        description: 'Dados, troqueles, moldes, matrices y herramental.',
      },
      { key: 'I06', description: 'Comunicaciones telefónicas.' },
      { key: 'I07', description: 'Comunicaciones satelitales.' },
      { key: 'I08', description: 'Otra maquinaria y equipo.' },
      {
        key: 'D01',
        description: 'Honorarios médicos, dentales y gastos hospitalarios.',
      },
      {
        key: 'D02',
        description: 'Gastos médicos por incapacidad o discapacidad.',
      },
      { key: 'D03', description: 'Gastos funerales.' },
      { key: 'D04', description: 'Donativos.' },
      {
        key: 'D05',
        description:
          'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)',
      },
      { key: 'D06', description: 'Aportaciones voluntarias al SAR.' },
      { key: 'D07', description: 'Primas por seguros de gastos médicos.' },
      {
        key: 'D08',
        description: 'Gastos de transportación escolarobligatoria.',
      },
      {
        key: 'D09',
        description:
          'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.',
      },
      {
        key: 'D10',
        description: 'Pagos por servicios educativos (colegiaturas)',
      },
      { key: 'P01', description: 'Por definir.' },
      { key: 'S01', description: 'Sin efectos fiscales.' },
      { key: 'CP01', description: 'Pagos.' },
      { key: 'CN01', description: 'Nómina.' },
    ];
    let find: any = CFDI.filter((r) => {
      return r.key == key;
    });
    return find[0] != null ? find[0] : null;
  }
}
